/* eslint-disable import/prefer-default-export */
import { createContext } from 'react';

const SnmpCactiContext = createContext({});
export default SnmpCactiContext;
